export default "__VITE_ASSET__BHBumHEu__"